import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
// eslint-disable-next-line
import $ from 'jquery';
// eslint-disable-next-line
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './index.css';
// eslint-disable-next-line
import { HashRouter } from "react-router-dom";
import App from './App';
import * as serviceWorker from './serviceWorker';

require('flexslider');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode> ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
